module.exports = "/_next/static/resources/life2-c0d603394c51f1fc3f1ddd62300f0f7c.webp";